module.exports = __webpack_public_path__ + "img/mail-outline.a6d8d119.svg";